export default __webpack_public_path__ + "2ea5e334fe7fd5775c70b78aab8ecf2e.svg";